import { Component } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { IPaperHistoryDialogData } from 'editing-tool/src/app/shared/components/paper/history/paper-history-dialog-data';
import { EnumLocalizingService } from 'sc-common';
import { ApiPaperHistoryEntry, PaperHistoryEventEnum, PaperStatusEnum } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    templateUrl: './paper-history-dialog.component.html',
    standalone: false
})
export class PaperHistoryDialogComponent {

    public readonly data: IPaperHistoryDialogData;

    constructor(dialogConfig: DynamicDialogConfig, private readonly _enumLocale: EnumLocalizingService) {
        this.data = dialogConfig.data;
    }

    public formatHistoryEntry(entry: ApiPaperHistoryEntry): string {
        switch (entry.event) {
            case PaperHistoryEventEnum.NewPaper:
                return $localize`New paper uploaded by ${ entry.performer }`;
            case PaperHistoryEventEnum.DocUploaded:
                return $localize`DOC uploaded by ${ entry.performer }`;
            case PaperHistoryEventEnum.PdfUploaded:
                return $localize`PDF uploaded by ${ entry.performer }`;
            case PaperHistoryEventEnum.AuthorAdded:
                return $localize`Author ${ entry.assignee } added by ${ entry.performer }`;
            case PaperHistoryEventEnum.AuthorRemoved:
                return $localize`Author ${ entry.assignee } deleted by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReferencesReloaded:
                return $localize`Paper references were reloaded by ${ entry.performer }`;
            case PaperHistoryEventEnum.KeywordsAdded:
                return $localize`Paper keywords were added by ${ entry.performer }`;
            case PaperHistoryEventEnum.KeywordsRemoved:
                return $localize`Paper keywords were deleted by ${ entry.performer }`;
            case PaperHistoryEventEnum.CopyrightSubmitted:
                return $localize`Copyright submitted by ${ entry.performer }`;
            case PaperHistoryEventEnum.PaperSubmitted:
                return $localize`Paper submitted by ${ entry.performer }`;
            case PaperHistoryEventEnum.ManualStatusChange:
                return $localize` Paper status changed from ${ this._localize(entry.oldStatus) } to ${ this._localize(entry.newStatus) } by ${ entry.performer }`;
            case PaperHistoryEventEnum.NoteAdded:
                return $localize`Paper comment was added by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewerAssigned:
                return $localize`Reviewer ${ entry.assignee } assigned by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewerUnassigned:
                return $localize`Reviewer ${ entry.assignee } unassigned by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewSubmitted:
                return $localize`Review added by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewApproved:
                return $localize`Review of ${ entry.assignee } approved by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewSentForReReview:
                return $localize`Review of ${ entry.assignee } sent to re-review by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewerAgreed:
                return $localize`Review agreed by ${ entry.performer }`;
            case PaperHistoryEventEnum.ReviewerRefused:
                return $localize`Review refused by ${ entry.performer }`;
            case PaperHistoryEventEnum.PaperMoved:
                return $localize`Paper moved to another Title by ${ entry.performer }`;
            case PaperHistoryEventEnum.PaperImported:
                return $localize`Paper copy imported from another Title by ${ entry.performer }`;
        }
    }

    private _localize(status: PaperStatusEnum): string {

        if (status === null) {
            return '';
        }

        return this._enumLocale.getName(PaperStatusEnum, status);
    }
}
